module.exports = __webpack_public_path__ + "static/media/Benjamin Harrison (I) - 1892.40f9f9a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Benjamin Harrison (I) - 1892.jpg
// module id = 444
// module chunks = 0